<template>
  <div class="login-for-management">
    <div class="password-input-form" v-if="!token">
      <base-text-input-password
        class="password-text-box"
        :placeholder="'パスワード'"
        v-model="password"
      />
      <base-button-medium-orange @click="fetchCustomerData" :disabled="waitFlg"
        >送信</base-button-medium-orange
      >
    </div>
    <div class="login-for-management-area" v-else>
      <slot :clinics="clinics"></slot>
    </div>
  </div>
</template>

<script>
import BaseButtonMediumOrange from '@/components/parts/atoms/BaseButtonMediumOrange'
import BaseTextInputPassword from '@/components/parts/atoms/BaseTextInputPassword'
import { getAxiosObject } from '@/utils/library'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginForManagement',

  components: {
    BaseButtonMediumOrange,
    BaseTextInputPassword
  },

  data() {
    return {
      password: process.env.NODE_ENV === 'development' ? 'password' : '',
      waitFlg: false
    }
  },

  computed: {
    ...mapGetters({
      token: 'pyxosManage/token',
      clinics: 'pyxosManage/clinics'
    })
  },

  methods: {
    async fetchCustomerData() {
      this.waitFlg = true
      try {
        const axiosObject = getAxiosObject()
        const res = await axiosObject.post('/customer-login-management', {
          password: this.password
        })
        this.$store.dispatch('pyxosManage/login', {
          token: res.data.token,
          clinics: res.data.clinics,
          noticeCategories: res.data.noticeCategories,
          loginHistories: res.data.loginHistories,
          viewOnlyFlg: res.data.viewOnlyFlg
        })
      } catch (error) {
        const text =
          error.response?.status === 400
            ? 'パスワードが異なります'
            : '通信エラーが起きました'
        alert(text)
      }
      this.waitFlg = false
    }
  }
}
</script>

<style lang="scss" scoped>
$page-width: 80px;
$cell-widths: (
  id: 60px,
  name: 260px,
  mail: 310px,
  last-login: 140px,
  status: 100px,
  contract-type: 130px,
  measurement-toggle: 90px,
  dev-toggle: 80px,
  account-toggle: 110px
);
@each $key, $width in $cell-widths {
  $page-width: $page-width + $width;
}

.login-for-management {
  box-sizing: border-box;
  min-width: $page-width;
  padding: 40px;
  display: flex;
  justify-content: center;
  > .password-input-form {
    display: flex;
    flex-flow: column;
    align-items: center;
    row-gap: 20px;
  }
}
</style>
